// Show loading screen

function showPanelLoadingScreen() {
  $('.panel-content-loading').addClass('panel-loading-active');
  $('#toggle-panel--calendar').addClass('button-disabled');
  $('.viewer-buttons').addClass('buttons-disabled');
}

function hidePanelLoadingScreen() {
  $('.panel-content-loading').removeClass('panel-loading-active');
  $('#toggle-panel--calendar').removeClass('button-disabled');
  $('.viewer-buttons').removeClass('buttons-disabled');
}

// Toggle panel

function togglePanel(id) {
  if ($('.panel__option--calendar.button-disabled').length) {
    return;
  }
  $('body').toggleClass('panel-active--' + id);
  resizeForgeViewAfterPanelResize();

  localStorage.setItem(
    'calendar-active',
    localStorage.getItem('calendar-active') === 'true' ? 'false' : 'true'
  );
}

function openPanel(id) {
  if ($('.panel__option--calendar.button-disabled').length) {
    return;
  }
  $('body').addClass('panel-active--' + id);
  resizeForgeViewAfterPanelResize();
  localStorage.setItem('calendar-active', 'true');
}

function closePanel(id) {
  if ($('.panel__option--calendar.button-disabled').length) {
    return;
  }
  $('body').removeClass('panel-active--' + id);
  resizeForgeViewAfterPanelResize();
  localStorage.setItem('calendar-active', 'false');
}

function resizeForgeViewAfterPanelResize() {
  setTimeout(function () {
    window.dispatchEvent(new Event('resize'));
  }, 220);

  setTimeout(function () {
    window.dispatchEvent(new Event('resize'));
  }, 440);
}

// Reset panels

function resetPanels() {
  resetNodesPanel();
  resetCalendarPanel();
  resetPropertiesPanel();
  resetIssuesPanel();
}

function resetNodesPanel() {
  $('#panel-content-map').removeClass('map-active').html('');
  $('#panel-content-tree').html('');
}

function resetCalendarPanel() {
  $('#panel-content-datepicker').html('');
  $('#panel-content-schedule').html('');
}

function resetPropertiesPanel() {
  $('.property-list__wrapper').html(
    '<div class="panel__empty">' + __('panelNoticeSelectNode') + '</div>'
  );
}

function resetIssuesPanel() {
  $('.issues__issues').html('');
}

// Activate a panel

function activatePanel(id) {
  $('.panel__option.panel-active, .panel__content.panel-active').removeClass(
    'panel-active'
  );
  $('#panel-option-' + id + ', #panel-content-' + id).addClass('panel-active');
  $('.panel__options-title').html(__($('#panel-option-' + id).attr('data-title')));
}

// Add node toggler

var categoryId = 0;
function addNodeToggler(
  name,
  options,
  container,
  viewer,
  autoOpen,
  calendarData,
  color
) {
  var id = categoryId++;

  // Check for node children
  var childrenAmount = Object.keys(options.children).length;
  var hasChildren = options.children && childrenAmount;

  // Build HTML
  var wrapper = $('<div class="category-tree__wrapper"/>').appendTo(container);

  if (options.limit) {
    wrapper.attr('data-value', name.replace('"', "'"));
  }

  var titleContainer = $(
    '<div class="category-tree__title-container"/>'
  ).appendTo(wrapper);

  // Children toggler
  var childrenToggler = $(
    '<div class="category-tree__children-toggler' +
      (hasChildren ? ' icon-right' : '') +
      (hasChildren && autoOpen ? ' children-active' : '') +
      '" data-id="' +
      id +
      '"/>'
  ).appendTo(titleContainer);

  // Title toggler
  titleContainer.append($('<div class="category-tree__title"/>').html(name));

  // Calendar data
  if (calendarData) {
    $.each(settings.calendar.cols.sort, function (index, item) {
      var calendarDataContainer = $(
        '<div class="category-tree__calendar-data-container" data-content="' +
          item.content +
          '" data-type="' +
          item.type +
          '"/>'
      );

      switch (item.content) {
        case 'startShouldIs':
          calendarDataContainer.html(
            getShortParsedDateFromIsoDate(options.startShould) +
              '<br>' +
              getShortParsedDateFromIsoDate(options.startIs)
          );
          break;
        case 'endShouldIs':
          calendarDataContainer.html(
            getShortParsedDateFromIsoDate(options.endShould) +
              '<br>' +
              getShortParsedDateFromIsoDate(options.endIs)
          );
          break;
        case 'durationShouldIs':
          var durationShould = getDayDifferenceFromIsoDate(
            options.endShould,
            options.startShould
          );
          var durationIs = getDayDifferenceFromIsoDate(
            options.endIs,
            options.startIs
          );
          calendarDataContainer.html(
            durationShould + ' d<br>' + durationIs + ' d'
          );
          break;
        case 'differenceDuration':
          var durationShould = getDayDifferenceFromIsoDate(
            options.endShould,
            options.startShould
          );
          var durationIs = getDayDifferenceFromIsoDate(
            options.endIs,
            options.startIs
          );
          var durationDifference = durationIs - durationShould;
          calendarDataContainer.html(
            (durationDifference > 0 ? '+' : '') + durationDifference + ' d'
          );
          break;
        case 'amount':
          if (hasChildren) {
            calendarDataContainer.html('&nbsp;');
          } else {
            var num = parseFloat(
              options.data[settings.calendar.cols.units.amount]
            );
            if (
              (num || parseInt(num) === 0) &&
              options.data[settings.calendar.cols.units.units]
            ) {
              calendarDataContainer.html(
                Math.round((num + Number.EPSILON) * 100) / 100 +
                  ' ' +
                  getParsedUnits(
                    options.data[settings.calendar.cols.units.units]
                  )
              );
            } else {
              calendarDataContainer.html('&nbsp;');
            }
          }
          break;
        case 'status':
          if (options.data[settings.calendar.cols.units.status]) {
            calendarDataContainer.html(
              options.data[settings.calendar.cols.units.status]
            );
          } else {
            calendarDataContainer.html('-');
          }
          break;
      }

      calendarDataContainer.appendTo(titleContainer);
    });
  }

  if (color) {
    $('<div class="category-tree__color-selector"/>')
      .html(
        '<div class="category-tree__color-indicator" style="background-color: ' +
          color +
          '">'
      )
      .appendTo(titleContainer);
  }

  // Visibility toggler
  var visibilityToggler = $(
    '<div class="category-tree__visibility-toggler icon-checkbox"/>'
  ).appendTo(titleContainer);

  visibilityToggler.data('nodeIds', options.ids);
  visibilityToggler.data('color', color || null);

  // TODO Improve performance

  visibilityToggler.on('click', function () {
    var isActive = visibilityToggler.hasClass('panel-list-active');

    if (isActive) {
      // Remove all parents that are active
      var parentWrappers = visibilityToggler.parents('.category-tree__wrapper');
      $.each(parentWrappers, function (index, wrapper) {
        var toggler = $(wrapper).find(
          '> .category-tree__title-container .category-tree__visibility-toggler'
        );
        if (toggler.hasClass('panel-list-active')) {
          deactivateVisibilityCheckbox(toggler);
        }
      });

      // If all children are active, remove all
      var childrenInactive = visibilityToggler
        .parent()
        .parent()
        .find('.category-tree__visibility-toggler.icon-checkbox');
      if (childrenInactive.length <= 1) {
        var childrenActive = visibilityToggler
          .parent()
          .parent()
          .find('.category-tree__visibility-toggler.icon-checkbox-checked');
        if (childrenActive.length) {
          childrenActive
            .removeClass('icon-checkbox-checked panel-list-active')
            .addClass('icon-checkbox');
        }
      }
    } else {
      // Activate toggler and all children
      var togglers = visibilityToggler
        .closest('.category-tree__wrapper')
        .find('.category-tree__visibility-toggler');
      activateVisibilityCheckbox(togglers);

      // If all childern are active, toggle parent
      var parentWrappers = visibilityToggler.parents('.category-tree__wrapper');
      $.each(parentWrappers, function (index, wrapper) {
        wrapper = $(wrapper);
        if (!wrapper.find('.icon-checkbox').length) {
          activateVisibilityCheckbox(
            wrapper.find('.category-tree__visibility-toggler')
          );
        }
      });
    }
    selectPanelListItems(viewer);
  });

  // Toggle children
  if (hasChildren) {
    childrenToggler.on('click', function () {
      toggleChildren(id);
    });

    var childrenAmount = Object.keys(options.children).length;

    var childContainer = $(
      '<div class="category-tree__children' +
        (autoOpen ? ' category-tree-active' : '') +
        (options.limit && childrenAmount > 25 ? ' category-tree-limit' : '') +
        '" data-id="' +
        id +
        '"/>'
    ).appendTo(wrapper);

    if (options.limit) {
      var sortedObj = Object.entries(options.children).sort(
        (a, b) => b[1].ids.length - a[1].ids.length
      );

      var colors = getColors(childrenAmount);

      $.each(sortedObj, function (index, data) {
        addNodeToggler(
          data[0],
          data[1],
          childContainer,
          viewer,
          false,
          calendarData,
          colors[index]
        );
      });
    } else {
      $.each(options.children, function (name, options) {
        addNodeToggler(
          name,
          options,
          childContainer,
          viewer,
          false,
          calendarData
        );
      });
    }

    if (options.limit && childrenAmount > 25) {
      $('<div class="category-tree__show-all-children"/>')
        .on('click', function () {
          var _this = $(this);
          var wrapper = _this.parent();
          wrapper.removeClass('category-tree-limit');
          _this.remove();
        })
        .html('Show all ' + childrenAmount + ' categories')
        .appendTo(childContainer);
    }
  }
}

function toggleChildren(id) {
  $('.category-tree__children-toggler[data-id="' + id + '"]').toggleClass(
    'children-active'
  );
  $('.category-tree__children[data-id="' + id + '"]').slideToggle();
}

function showChildren(id) {
  $('.category-tree__children-toggler[data-id="' + id + '"]').addClass(
    'children-active'
  );
  $('.category-tree__children[data-id="' + id + '"]').slideDown();
}

function hideChildren(id) {
  $('.category-tree__children-toggler[data-id="' + id + '"]').removeClass(
    'children-active'
  );
  $('.category-tree__children[data-id="' + id + '"]').slideUp();
}

function activateVisibilityCheckbox(togglers) {
  togglers.removeClass('icon-checkbox');
  togglers.addClass('icon-checkbox-checked panel-list-active');
}

function deactivateVisibilityCheckbox(togglers) {
  togglers.removeClass('icon-checkbox-checked panel-list-active');
  togglers.addClass('icon-checkbox');
}

// Add map link

function addMapLink(id, name, dbIdsAll, dbIds, viewer) {
  var container = $('#panel-content-map');
  container.addClass('map-active');
  var wrapper = $(
    '<div class="map-select__wrapper map-select__wrapper-' + id + '"/>'
  ).appendTo(container);
  var toggler = $('<div class="map-select__radio-button icon-radio-button"/>');
  toggler.data('map-nodes', dbIds);
  toggler.data('map-nodes-all', dbIdsAll);

  toggler.on('click', function () {
    setMapImage(id);
    selectPanelListItems(viewer);
  });

  wrapper.append(toggler);
  wrapper.append($('<div class="map-select__title"/>').html(name));
}

// Set map image

function setMapImage(id) {
  $('.map-select__wrapper .icon-radio-button-checked')
    .removeClass('icon-radio-button-checked')
    .addClass('icon-radio-button');
  $('.map-select__wrapper-' + id + ' .icon-radio-button')
    .removeClass('icon-radio-button')
    .addClass('icon-radio-button-checked');
}

// Create the properties panel

var mapLinkId = 1;
function addPropertiesPanel(viewer, data, list) {
  if (!data || !list || !list.length) {
    addNoNodesNotice();
  }

  // Add map options
  var map = settings.map;
  $('#panel-content-map').html('');
  if (
    map &&
    map.key &&
    data._mapData &&
    data._mapData.all &&
    data._mapData.all.length
  ) {
    addMapLink('none', 'Without map', data._mapData['all'], [], viewer);

    $.each(map.values, function (index, item) {
      addMapLink(
        mapLinkId,
        //item.name, DMue 20230315
        item.name,
        data._mapData['all'],
        data._mapData[item.value],
        viewer
      );
      mapLinkId++;
    });
  }
  setMapImage('none');

  if (!data._treeData) {
    if (!$('.map-select__wrapper').length) {
      addNoNodesNotice();
    }
    return;
  }

  // Add nodes
  var panelEl = $('#panel-content-tree');
  panelEl.html('');
  $.each(data._treeData, function (name, options) {
    addNodeToggler(name, options, panelEl, viewer, true);
  });

  // Inital filter
  selectPanelListItems(viewer);

  // Add no nodes notice
  if (
    !$('.map-select__wrapper').length &&
    !$('#panel-content-tree .category-tree__wrapper').length
  ) {
    addNoNodesNotice();
  }
}

function addNoNodesNotice() {
  $('#panel-content-tree').append(
    $('<div class="panel__empty"/>').html(
      'There are no nodes defined<br>in this project.'
    )
  );
}

// Set panel list item

function selectPanelListItems(viewer, zoom, manualIds, manualColor) {
  restoreAllColorMaterial();
  clearDbIdColors();
  var activePanels = $('.category-tree__visibility-toggler.panel-list-active');

  var ids = [];
  if (activePanels.length) {
    $.each(activePanels, function (index, item) {
      var itemIds = $(item).data('nodeIds');
      $.merge(ids, itemIds);
      if ($(item).data('color')) {
        addDbIdsToColor(itemIds, $(item).data('color'));
      }
    });
  } else if (manualIds) {
    $.merge(ids, manualIds);
  } else {
    var itemIds = $(
      '.category-tree__wrapper > .category-tree__title-container .category-tree__visibility-toggler'
    ).data('nodeIds');
    if (itemIds && itemIds.length) {
      $.merge(ids, itemIds);
    }
    // TODO else show error
  }

  if (manualColor) {
    // Manual color for all elements
    setColorMaterial(ids, manualColor);
  } else if (Object.keys(dbIdColors).length) {
    $.each(dbIdColors, function (color, colorIds) {
      setColorMaterial(colorIds, color);
    });
  }

  var activeMapToggler = $(
    '.map-select__radio-button.icon-radio-button-checked'
  );
  var mapNodes = activeMapToggler.data('map-nodes') || [];
  var mapNodesAll = activeMapToggler.data('map-nodes-all') || [];

  var isolateMode = localStorage.getItem('isolate-mode') == '1';
  var useIsolateMode = isolateMode;

  var flipIsolateMode = $('.viewer-button.icon-flip').hasClass('flip-active');
  if (flipIsolateMode) {
    useIsolateMode = !useIsolateMode;
  }

  // Don't use isolate mode when there are no nodes
  if (!$('.category-tree__visibility-toggler').length) {
    useIsolateMode = false;
  }

  var zoomMode = localStorage.getItem('zoom-mode') == '1';
  var useZoomMode = zoom === false ? false : zoom || zoomMode;

  if (useIsolateMode) {
    viewer.isolate([]);

    $.each(leaves, function (index, id) {
      viewer.impl.visibilityManager.setNodeOff(id, true);
    });

    $.each(ids, function (index, id) {
      viewer.impl.visibilityManager.setNodeOff(id, false);
    });

    if (useZoomMode) {
      viewer.fitToView(ids);
    }
  } else {
    $.each(leaves, function (index, id) {
      viewer.impl.visibilityManager.setNodeOff(id, false);
    });

    $.each(mapNodesAll, function (index, id) {
      viewer.impl.visibilityManager.setNodeOff(id, true);
    });

    $.each(mapNodes, function (index, id) {
      viewer.impl.visibilityManager.setNodeOff(id, false);
    });

    if (useZoomMode) {
      viewer.fitToView(ids);
    }

    $.merge(ids, mapNodes);
    viewer.isolate(ids);
  }
}

// Clear all

function clearAllNodes(select) {
  deactivateVisibilityCheckbox(
    $('.category-tree__visibility-toggler.panel-list-active')
  );
  select && selectPanelListItems(viewer);
}
